import React from 'react';
import update from 'react-addons-update';
import PropTypes from 'prop-types';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMUserResource from 'resources/SMUserResource';
import SMUFavoriteListSelectView from './SMUFavoriteListSelectView';
import SMUFavoriteDeleteView from './SMUFavoriteDeleteView';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';

class SMUFavoriteView extends SMDashboardBaseView {

  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      isSMUFavoriteListSelectViewOpen: false,
      isFavoriteDeleteViewOpen: false,
      isMemoUpdated: false,
      room: this.props.room,
      isOpenMemo: false,
      errorText: ""
    };
  }

  // メモの更新を親Component(SMUFavoriteListDetailView)に渡す
  updateState(state){
    this.props.updateState(state);
  }

  removeFavorite() {
    //親Component(お気に入り一覧)のメソッドを呼び、お気に入り一覧を更新する。
    this.props.removeFavorite();
  }

  showFavoriteListSelectForm(e){
    if (e) e.preventDefault();

    this.setState({
      isSMUFavoriteListSelectViewOpen: true,
    });
  }

  favoriteListSelectViewDidClose() {
    this.setState({
      isSMUFavoriteListSelectViewOpen: false,
    });
  }

  showFavoriteDeleteForm(e) {
    if (e) e.preventDefault();

    this.setState({
      isFavoriteDeleteViewOpen: true,
    });
  }

  toggleMemoForm(e) {
    e.preventDefault();
    const isOpen = !this.state.isOpenMemo;
    this.setState({isOpenMemo: isOpen});
  }

  favoriteDeleteViewDidClose() {
    this.setState({
      isFavoriteDeleteViewOpen: false,
    });
  }

  textDidUpdate(e) {
    let memo = this.refs.memo.value;
    this.setState({
      isMemoUpdated: true,
      room: update(this.state.room, {$merge: {memo: memo}})
    });
  }

  formDidSubmit(e) {
    e.preventDefault();
    let memo = this.refs.memo.value;
    let responseHandler = (data, error, xhr)=>{
      if (error) {
        if (xhr.responseJSON.message) {
          this.setState({errorText: xhr.responseJSON.message,});
        } else {
          this.setState({errorText: I18n.t("dashboard.error_000001"),});
        }
      } else {
        this.setState({
          room: update(this.state.room, {$merge: {memo: data.memo}}),
          isMemoUpdated: false
        });
        this.updateState(this.state);
      }
    };
    SMUserResource.updateListedFavorite(this.props.user.username, this.props.favoriteList.id, this.props.room.id, "Room", memo, responseHandler);
  }

  renderMemoCounter(isMemoWithinMaxLength, room) {
    const smMemoShow = this.state.isOpenMemo ? '' : 'sm-hide';
    if(isMemoWithinMaxLength) {
      return (
        <p className={"dashboard-favorite__space-info-memo-count "+ smMemoShow}>残り{400 - room.memo.length}文字</p>
      );
    } else {
      return (
        <p className={"dashboard-favorite__space-info-memo-count-overflow "+ smMemoShow}>{400 - room.memo.length}文字</p>
      );
    }
  }

  renderRoomPriceText(room){
    return SMFormatHelper.renderRoomPriceText(room);
  }

  render() {
    let room = this.state.room;
    const favoriteStyle = room.registered_favorite_lists.includes(this.props.favoriteList.id) ?  {} : {display: "none"};
    let saveMemoButtonColor,
        isDisabled,
        isMemoWithinMaxLength;
    if (room.memo.length <= 400) {
      isMemoWithinMaxLength = true;
    } else {
      isMemoWithinMaxLength = false;
    }

    if (room.memo.length <= 400 && this.state.isMemoUpdated) {
      isDisabled = false;
      saveMemoButtonColor = 'button-blue';
    } else {
      isDisabled = true;
      saveMemoButtonColor = 'button-disabled';
    }

    const smMemoButtonColor = room.memo.length > 0 ? 'button-green' : 'button-gray';
    const smMemoShow = this.state.isOpenMemo ? '' : 'sm-hide';

    return (
      <div style={favoriteStyle} className="dashboard-favorite__space">
        <a href={Routes.space_room_path(room.space.username, room.uid)} className="dashboard-favorite__space-box">
          <img className="dashboard-favorite__space-box-img" src={SMFormatHelper.roomImageURL(room, {width: 490, height: 490})} alt={room.name}></img>
          {this.renderRoomPriceText(room)}
        </a>
        <div className="dashboard-favorite__space-info">
          <div className="dashboard-favorite__space-info-text">
            <a href={Routes.space_room_path(room.space.username, room.uid)} >
              <h3 className="dashboard-favorite__space-info-text-title">{SMFormatHelper.roomName(room)}</h3>
            </a>
            <ul className="dashboard-favorite__space-info-feature">
              <li className="dashboard-favorite__space-info-feature-content"><i className="fa fa-user ashboard-favorite__space-info-feature-icon mr5"></i>{SMFormatHelper.capacity(room)}</li>
              <li className="dashboard-favorite__space-info-feature-content"><i className="fa fa-map-marker ashboard-favorite__space-info-feature-icon mr5"></i>{room.space.state_text}</li>
              <li className="dashboard-favorite__space-info-feature-content">{SMRenderHelper.renderReviewStars(room.reputation_score)}{room.reputation_count}件</li>
              <li className="dashboard-favorite__space-info-feature-content">{room.space.access}</li>
            </ul>
          </div>
          <div className="dashboard-favorite__space-info-setting">
            <p className="dashboard-favorite__space-info-setting-button"><a href="#" onClick={this.showFavoriteListSelectForm.bind(this)} className="button-gray dashboard-favorite__space-info-button-select">リストの選択</a></p>
            <p className="dashboard-favorite__space-info-setting-button"><a href="#" onClick={this.showFavoriteDeleteForm.bind(this)} className="button-gray dashboard-favorite__space-info-button-delete">削除</a></p>
            <p className="pc-hide__sm-show dashboard-favorite__space-info-setting-button"><a href="#" onClick={this.toggleMemoForm.bind(this)} className={"dashboard-favorite__space-info-memo-open "+smMemoButtonColor}>メモ<i className="fa fa-caret-down dashboard-favorite__space-info-memo-area-icon"></i></a></p>
          </div>
          <form className="dashboard-favorite__space-info-memo" ref="form" onSubmit={this.formDidSubmit.bind(this)}>
            <span className={smMemoShow}>
              <textarea ref="memo" value={room.memo} name="content" className="dashboard-favorite__space-info-memo-area" onChange={this.textDidUpdate.bind(this)} placeholder="メモを書く" />
            </span>
            <div className="dashboard-favorite__space-info-memo-setting">
              {this.renderMemoCounter(isMemoWithinMaxLength, room)}
              <input type="submit" name="commit" value="メモを保存" disabled={isDisabled} className={"dashboard-favorite__space-info-memo-save "+saveMemoButtonColor + " " +smMemoShow} />
            </div>
          </form>
        </div>
        <SMUFavoriteListSelectView
          room={room}
          delegate={this}
          user={this.props.user}
          isOpen={this.state.isSMUFavoriteListSelectViewOpen}
          noFavoriteListImage={this.props.noFavoriteListImage} />
        <SMUFavoriteDeleteView
          room={room}
          delegate={this}
          favoriteList={this.props.favoriteList}
          user={this.props.user}
          isOpen={this.state.isFavoriteDeleteViewOpen}
          removeFavorite={this.removeFavorite.bind(this)} />
      </div>
    );
  }
}

SMUFavoriteView.propTypes = {
  user: PropTypes.object.isRequired
};
export default SMUFavoriteView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/SMUFavoriteView.jsx